<template>
  <section class="services-area ptb-70">
    <div class="container-fluid p-0">
      <div class="overview-box">
        <div class="overview-content">
          <div class="content left-content">
            <h2>Cash out via USSD</h2>
           
            <p>
              Customers can collect cash from their bank account at merchant locations using their bank specific USSD short codes.
            </p>
            <ul class="services-list">
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Reduces cash handling at business premises
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Lowest possible charge
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Not dependent on internet or ATM network
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Instant notification/confirmation
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="overview-image">
          <div class="image">
            <img src="assets/img/3.png" alt="image" />
           
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>